<template>
<div v-if="occupation" class="room-modal-order__tourists">

    <label class="custom-radio" v-for="opt in occupation.list"  :key="opt.adultChild">
        <input
            type="radio"
            name="occupation_list"
            :value="opt.adultChild"
            v-model="occrec"
      >
        {{vzros(opt.adult)}}
        <span v-if="opt.child" >
            + {{rebenok(opt.child)}}
            (<SinceTill :agesLine="occupation.ages.child" />)
        </span>
    </label>

    <MyCheckbox v-if="occupation.ages.infant.till" :choosed="infant_str" @input="set_infant" class="room-modal-order__checkbox">
        <span :title="occupation.ages.infant.src">Добавить в каюту ребенка <SinceTill :agesLine="occupation.ages.infant" /> без места и питания</span>
    </MyCheckbox>
    <div v-else class="room-modal-order__checkbox">
        В данном круизе бронирование детей возможно <span :title="occupation.ages.infant.src">только с местом</span>
    </div>

</div>
</template>


<script setup>
import './RoomSelector.scss'
import {ref, unref, computed, onMounted, watch, nextTick} from 'vue'
import useCruiseStore from '@/cstore.js'
import useCabinsStore from '@/bookCabins.js'

import MyCheckbox from '@/comp/MyCheckbox/MyCheckbox.vue'
import { numWord } from '@/util.js'

import SinceTill from './SinceTill.vue'


const cstore = useCruiseStore()
const bookCabins = useCabinsStore()

const props = defineProps({
    Cabin : Object,
})


const occupation = bookCabins.getOccupation( props.Cabin.id )


const infant_str = computed(() => {
    let v = unref(occupation).infant ? '1' : ''
    return v
})
const set_infant = v => {
    const {id:cabinId} = props.Cabin
    const infant = v ? 1 : 0
    bookCabins.setInfant(  { cabinId, infant } )
}

const occrec = computed({
    get() {
        return unref(occupation).adultChild
    },
    set(adultChild) {
        const {id:cabinId} = props.Cabin
        bookCabins.setOccRec(  { cabinId, adultChild } )
    }
})




/*
будет размещено 5 человек
размещено 5
2 места (+1)
5 гостей
*/
const gostey = ({adult, child, infant}) => {
    const num = adult+child+infant
    const ret = numWord(num, ['гость', 'гостя', 'гостей'])
    return ret
}

const vzros = (num) => {
    const ret = numWord(num, ['взрослый', 'взрослых', 'взрослых'])
    return ret
}
const rebenok = (num) => {
    const ret = numWord(num, ['ребенок', 'ребенка', 'ребенка'])
    return ret
}



</script>
